"use client";

import Carousel from "./common/Carousel";
import ChooseGailCard from "./ChooseGailCard";
import FadeDiv from "./common/FadeDiv";
import React from "react";
import SectionTitle from "./common/SectionTitle";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const ChooseGail: React.FC = () => {
  const { t } = useTranslation();

  const features = [
    {
      percentage: 28,
      title: t("chooseGail.revenue.title"),
    },
    {
      percentage: 65,
      title: t("chooseGail.time.title"),
    },
    {
      percentage: 32,
      title: t("chooseGail.conversion.title"),
    },
  ];

  return (
    <>
      <div className={clsx("max-w-8xl", "mx-auto")}>
        <FadeDiv className={clsx("", "bg-white")}>
          <SectionTitle
            title={t("chooseGail.heading")}
            className="!p-0 !pt-16 !pb-6 text-[40px] md:max-w-8xl mx-auto"
          />
        </FadeDiv>
        <div className={clsx("md:hidden")}>
          <Carousel
            itemClassName="!p-0"
            itemWidth="80%"
            showControls={false}
            items={features.map((feature) => (
              <ChooseGailCard
                key={feature.percentage}
                percentage={feature.percentage}
                title={feature.title}
              />
            ))}
          />
        </div>
        <div
          className={clsx(
            "mt-4",
            "md:mt-8",
            "border-l",
            "border-r",
            "border-gray-200",
            "hidden",
            "md:block"
          )}
        >
          <hr
            className={clsx(
              "absolute",
              "w-screen",
              "left-0",
              "border-gray-200"
            )}
          />
          <div
            className={clsx(
              "grid",
              "gap-[1px]",
              "md:grid-cols-3",
              "bg-gray-200"
            )}
          >
            {features.map((feature, index) => (
              <ChooseGailCard
                key={index}
                percentage={feature.percentage}
                title={feature.title}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="h-16">
        <div
          className={clsx(
            "h-16",
            "bg-gradient-to-r",
            "from-[#EAE3DA]",
            "to-[#369BD5]"
          )}
        ></div>
      </div>
    </>
  );
};

export default ChooseGail;
